import { ApiClient } from 'app/service/api-service'
import { DegreeEndPoint } from './constant'
import {
  IParamsGetDegree,
  IPayloadCreateDegree,
  IPayloadUpdateDegree,
} from './model'

export const requestGetDegree = (body: IParamsGetDegree) =>
  ApiClient.Post({
    url: DegreeEndPoint.GET,
    body,
  })

export const requestPostCreateDegree = (body: IPayloadCreateDegree) =>
  ApiClient.Post({
    url: DegreeEndPoint.CREATE,
    body,
  })

export const requestUpdateDegree = (body: IPayloadUpdateDegree) =>
  ApiClient.Put({
    url: DegreeEndPoint.UPDATE,
    body,
  })

export const requestDeleteDegree = (listId: number[]) =>
  ApiClient.Put({
    url: DegreeEndPoint.DELETE,
    body: { listId },
  })

// get detail unit
export const requestGetDetailDegree = (id: number) =>
  ApiClient.Get({
    url: DegreeEndPoint.DETAIL,
    params: { id },
  })
